export default "__VITE_ASSET__BLDWDbXt__"